/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { inventoryCreatePublication } from '../fn/inventory-publications-controller/inventory-create-publication';
import { InventoryCreatePublication$Params } from '../fn/inventory-publications-controller/inventory-create-publication';
import { inventoryDeletePublication } from '../fn/inventory-publications-controller/inventory-delete-publication';
import { InventoryDeletePublication$Params } from '../fn/inventory-publications-controller/inventory-delete-publication';
import { inventoryGetPublication } from '../fn/inventory-publications-controller/inventory-get-publication';
import { InventoryGetPublication$Params } from '../fn/inventory-publications-controller/inventory-get-publication';
import { inventoryGetPublications } from '../fn/inventory-publications-controller/inventory-get-publications';
import { InventoryGetPublications$Params } from '../fn/inventory-publications-controller/inventory-get-publications';
import { inventoryUpdatePublication } from '../fn/inventory-publications-controller/inventory-update-publication';
import { InventoryUpdatePublication$Params } from '../fn/inventory-publications-controller/inventory-update-publication';
import { movePublicationToGlobal } from '../fn/inventory-publications-controller/move-publication-to-global';
import { MovePublicationToGlobal$Params } from '../fn/inventory-publications-controller/move-publication-to-global';
import { Publication } from '../models/publication';
import { PublicationWithRelations } from '../models/publication-with-relations';

@Injectable({ providedIn: 'root' })
export class InventoryPublicationsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `publicationControllerMovePublicationToGlobal()` */
  static readonly PublicationControllerMovePublicationToGlobalPath = '/inventory/publications/move-to-global';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `movePublicationToGlobal()` instead.
   *
   * This method doesn't expect any request body.
   */
  movePublicationToGlobal$Response(params: MovePublicationToGlobal$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return movePublicationToGlobal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `movePublicationToGlobal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  movePublicationToGlobal(params: MovePublicationToGlobal$Params, context?: HttpContext): Observable<any> {
    return this.movePublicationToGlobal$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `publicationControllerInventoryGetPublication()` */
  static readonly PublicationControllerInventoryGetPublicationPath = '/inventory/publications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetPublication()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetPublication$Response(params: InventoryGetPublication$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicationWithRelations>> {
    return inventoryGetPublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetPublication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetPublication(params: InventoryGetPublication$Params, context?: HttpContext): Observable<PublicationWithRelations> {
    return this.inventoryGetPublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<PublicationWithRelations>): PublicationWithRelations => r.body)
    );
  }

  /** Path part for operation `publicationControllerInventoryUpdatePublication()` */
  static readonly PublicationControllerInventoryUpdatePublicationPath = '/inventory/publications/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryUpdatePublication()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdatePublication$Response(params: InventoryUpdatePublication$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryUpdatePublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryUpdatePublication$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryUpdatePublication(params: InventoryUpdatePublication$Params, context?: HttpContext): Observable<any> {
    return this.inventoryUpdatePublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `publicationControllerInventoryGetPublications()` */
  static readonly PublicationControllerInventoryGetPublicationsPath = '/inventory/publications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryGetPublications()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetPublications$Response(params: InventoryGetPublications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicationWithRelations>>> {
    return inventoryGetPublications(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryGetPublications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryGetPublications(params: InventoryGetPublications$Params, context?: HttpContext): Observable<Array<PublicationWithRelations>> {
    return this.inventoryGetPublications$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PublicationWithRelations>>): Array<PublicationWithRelations> => r.body)
    );
  }

  /** Path part for operation `publicationControllerInventoryCreatePublication()` */
  static readonly PublicationControllerInventoryCreatePublicationPath = '/inventory/publications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryCreatePublication()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreatePublication$Response(params: InventoryCreatePublication$Params, context?: HttpContext): Observable<StrictHttpResponse<Publication>> {
    return inventoryCreatePublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryCreatePublication$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventoryCreatePublication(params: InventoryCreatePublication$Params, context?: HttpContext): Observable<Publication> {
    return this.inventoryCreatePublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<Publication>): Publication => r.body)
    );
  }

  /** Path part for operation `publicationControllerInventoryDeletePublication()` */
  static readonly PublicationControllerInventoryDeletePublicationPath = '/inventory/publications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventoryDeletePublication()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeletePublication$Response(params: InventoryDeletePublication$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return inventoryDeletePublication(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventoryDeletePublication$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inventoryDeletePublication(params: InventoryDeletePublication$Params, context?: HttpContext): Observable<any> {
    return this.inventoryDeletePublication$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
